import { APP_SETTINGS } from "./env";
import React from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  HashRouter,
} from "react-router-dom";
import Login from "./component/Auth/Login";
import Translator from "./component/Document/Translator";
import { servicesClient } from "./index"; // Import the servicesClient
import { axiosInstance } from "./fetcher";

const onLogout = () => {
  console.log("Logout function called");
  // Send a request to the server to log out the user
  axiosInstance
    .post("/logout")
    .then((response) => {
      console.log("Logout response:", response);
      if (response.status === 200) {
        // Redirect to login page after successful logout
        window.location.href = "#/login";
      }
    })
    .catch((error) => {
      console.error("Error logging out:", error);
    });
};

const RouteConfig = () => {
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  console.log("Is admin- ", isAdmin);
  return (
    <HashRouter>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/" element={<Navigate to="/login" />} />
        <Route
          path="/translator"
          element={<Translator isAdmin={isAdmin} onLogout={onLogout} />}
        />
      </Routes>
    </HashRouter>
  );
};

export default RouteConfig;
